module.exports = "##### Pink\n"